// TextInputControlView

import eventBus from 'EventBus'
import BaseControlView from 'BaseControlView';
import constants        from "Constants";
import template from 'common-inputs/control-text-input.ejs';

//=====================================================================
//
// An instance of this view represents a text input control.
//
// Brad Trebilcock, January, 15 2016
//
//=====================================================================
class TextInputControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-text-input';

        this.events = {
            'dblclick div.pf-editable' : 'handleDblClick',
            'change input[type=text]': 'updateAttributes'
        };

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
       
        return this;
    }
  
    updateAttributes(ev) {
        const
            propName = ev.currentTarget.name,
            propVal = ev.currentTarget.value;
        window.setTimeout(() => this.model.set(propName, propVal));
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

}

export default TextInputControlView;
